import React from 'react'
import { useState } from 'react'
import FiringModal from './FiringModal'
import styles from './FiringModal.module.css'
import { useEffect } from 'react'
import { axiosInstance } from '../../Helpers/axiosInstance'

export default function FiringParts({changeSelectedBase, base, baseList, closeModal, currentUnit, firingInfo, firingIndex, fetchFiringInfo, setAdded}) {
    const [who, setWho] = useState("us")
    const [date, setGetDate] = useState(new Date().getTime())
    const [firedBy, setFiredBy] = useState({date: date + "",us: {fire: 0, mina: 0, signal: 0, date: new Date(), weapon: []}, we: {fire: 0, mina: 0, signal: 0, date: new Date(), weapon: []}})
    const [title, setTitle] = useState(!firingInfo ? 'Հաստատել' : 'Փոփոխել')
    const [selected, setSelected] = useState(null)

useEffect(() => {
    selected && changeSelectedBase(baseList[selected])
}, [selected])

    const adding = async () => {
        const res = await axiosInstance.post('admin/firing', {
            base_number: base.base_number,
            mil_unit_number: currentUnit.number,
            mil_unit_name: currentUnit.name,
            corpus: currentUnit.corpus,
            fired: firedBy
        })
        if(res.data.status){
            closeModal()
            setAdded(true)
        }
    }

    const editing = async() => {
        const res = await axiosInstance.put('admin/firing', {
            firedBy,
            base_number: base.base_number,
            index: firingIndex
        })
        if(res.data.status){
            fetchFiringInfo()
            closeModal()
        }
    }
  return (
    <div className={styles['modal']}>
        <div className={styles['modal-info']}>
            <h3 className={styles['header']}>Մուտքագրել գնդակոծման մասին տեղեկավությունը</h3>
            <div className={styles['base-select-container']}>
                <div className={styles['base-select-div']}>
                    <label htmlFor="base">Հենակետ</label>
                    <select id="base" className={styles['base-select']} onChange={(e) => setSelected(e.target.value)} value={baseList?.findIndex(item => item._id === base._id)}>
                        {baseList?.map((item, index) => (
                            <option key={index} value={index}>{item.base_number}</option>
                        ))}
                    </select>
                </div>
            </div>
            <div className={styles['who-container']}>
                <p className={who === "us" ? styles['activ'] : ""} onClick={() => setWho("us")}>Հակարակորդի կողմից</p>
                <p className={who === "we" ? styles['activ'] : ""} onClick={() => setWho("we")}>Պատասխան կրակ</p>
            </div>
            <FiringModal who={who} setFiredBy={setFiredBy} firedBy={firingInfo ? firingInfo.fired : firedBy} setGetDate={setGetDate} firedIndex={firingIndex}/>
            <div className={styles['modal-info-buttons']}>
                    <button disabled={!firingInfo && (!firedBy.us.weapon.length && !firedBy.us.fire && !firedBy.us.mina && !firedBy.us.signal && !firedBy.we.weapon.length && !firedBy.we.fire && !firedBy.we.mina && !firedBy.we.signal || !firedBy.date)} className={styles['accept']} onClick={firingInfo ? editing : adding }>{title}</button>
                    <button className={styles['cencel']} onClick={closeModal}>Չեղարկել</button>
            </div>
        </div>
    </div>
  )
}
